<template>
  <footer class="bg-gradient-to-b from-slate-50 to-slate-100 border-t border-slate-200 py-5 px-4 pb-safe">
    <div class="flex flex-col items-center gap-3 max-w-lg mx-auto">
      <img
        src="@/assets/companyLogo.png"
        alt="Neutral Fuels"
        class="h-8 w-auto opacity-80"
      />
      <p class="text-xs text-slate-500 text-center leading-relaxed">
        &copy; {{ currentYear }} The Neutral Fuels Group of Companies
      </p>
      <span class="inline-block px-3 py-1 bg-slate-200 text-slate-600 text-[10px] font-semibold rounded-full uppercase tracking-wide">
        {{ versionNumber }}
      </span>
    </div>
  </footer>
</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";

export default {
  setup() {
    const store = useStore();
    const currentYear = ref(new Date().getFullYear());

    return {
      versionNumber: computed(() => store.state.versionNumber),
      currentYear,
    };
  },
};
</script>

<style scoped>
/* Safe area bottom padding */
.pb-safe {
  padding-bottom: calc(1.25rem + env(safe-area-inset-bottom));
}

@supports not (padding: env(safe-area-inset-bottom)) {
  .pb-safe {
    padding-bottom: 1.25rem;
  }
}
</style>
